import * as actionTypes from './actionTypes';
import reduce from '../reduce';

const initialState = {
    task: null,
    taskAccessKey: null,
    imgSegmentQuestion: null,
    imgSegmentDataset: null,
    query: null,
    error: null,
    openLightbox: false,
    imgObjNos: [
        { num: 1 },{ num: 2 },{ num: 3 },{ num: 4 },{ num: 5 },{ num: 6 },{ num: 7 },{ num: 8 },{ num: 9 },{ num: 10 },
        { num: 11 },{ num: 12 },{ num: 13 },{ num: 14 },{ num: 15 },{ num: 16 },{ num: 17 },{ num: 18 },{ num: 19 },{ num: 20 },
        { num: 21 },{ num: 22 },{ num: 23 },{ num: 24 },{ num: 25 },{ num: 26 },{ num: 27 },{ num: 28 },{ num: 29 },{ num: 30 },
        { num: 31 },{ num: 32 },{ num: 33 },{ num: 34 },{ num: 35 },{ num: 36 },{ num: 37 },{ num: 38 },{ num: 39 },{ num: 40 },
        { num: 41 },{ num: 42 },{ num: 43 },{ num: 44 },{ num: 45 },{ num: 46 },{ num: 47 },{ num: 48 },{ num: 49 },{ num: 50 },
        { num: 51 },{ num: 52 },{ num: 53 },{ num: 54 },{ num: 55 },{ num: 56 },{ num: 57 },{ num: 58 },{ num: 59 },{ num: 60 },
        { num: 61 },{ num: 62 },{ num: 63 },{ num: 64 },{ num: 65 },{ num: 66 },{ num: 67 },{ num: 68 },{ num: 69 },{ num: 70 },  
        { num: 71 },{ num: 72 },{ num: 73 },{ num: 74 },{ num: 75 },{ num: 76 },{ num: 77 },{ num: 78 },{ num: 79 },{ num: 80 },
        { num: 81 },{ num: 82 },{ num: 83 },{ num: 84 },{ num: 85 },{ num: 86 },{ num: 87 },{ num: 88 },{ num: 89 },{ num: 90 },
        { num: 91 },{ num: 92 },{ num: 93 },{ num: 94 },{ num: 95 },{ num: 96 },{ num: 97 },{ num: 98 },{ num: 99 },{ num: 100 }    
    ],
    imgSegmentForm: null,
    taskCompleted: false,
    taskContinue: false,
    imgSegmentDatasets: [],
    count: 0,
    page: 1,
    pageSize: 5,
    pages: 0,
    sortField: 'task_seq',
    sortOrder: 'asc',
    imgSegmentQuestionId: null
}

const queryReceived=(state,action)=>{
    return {
        ...state,
        query: action.query
    }
}

//In use
const getTaskConfigSuccess=(state,action)=>{
    let task = action.task
    if (task.task_param_values){
        task.task_param_values = JSON.parse(task.task_param_values)
    }
    return {
        ...state,
        task: task,
        taskAccessKey: action.taskAccessKey
    }
}
//In use
const getTaskConfigError=(state,action)=>{
    return {
        ...state,
        error: action.error
    }
}
//In use
const openLightbox=(state)=>{
    return {
        ...state,
        openLightbox: true
    }
}
//In use
const closeLightbox=(state)=>{
    return {
        ...state,
        openLightbox: false
    }
}
//In use
const updateAnswer = (state, action) => {
    return {
        ...state,
        imgSegmentForm: action.imgSegmentForm
    }
}

const submitError = (state, action)=>{
    return {
        ...state,
        error: action.error
    }
}

const submitSuccess = (state,action)=> {
    return {
        ...state,
        taskCompleted: action.taskCompleted,
        taskContinue: action.taskContinue,
        error: null,
    }
}

const taskCompleted = (state) =>{
    return {
        ...state,
        taskCompleted: false,
        imgSegmentForm: null
    }
}

const getCurrentQuestionSuccess=(state,action)=>{
    return {
        ...state,
        imgSegmentQuestion: action.imgSegmentQuestion,
        taskContinue: action.taskContinue
    }
}

const getCurrentQuestionError = (state, action)=>{
    return {
        ...state,
        error: action.error
    }
}

const getNextSegmentDatasetSuccess=(state,action)=>{
    return {
        ...state,
        imgSegmentDataset: action.imgSegmentDataset
    }
}

const getNextSegmentDatasetError = (state, action)=>{
    return {
        ...state,
        error: action.error
    }
}

const receivedImgSegmentDatasets=(state,action)=>{
    const { imgSegmentQuestionId,imgSegmentDatasets,count,page,pageSize,pages,sortField,sortOrder} = action.data;
    return {
        ...state,
        imgSegmentQuestionId: imgSegmentQuestionId,
        imgSegmentDatasets: imgSegmentDatasets,
        count: count,
        page: page,
        pageSize: pageSize,
        pages: pages,
        sortField: sortField,
        sortOrder: sortOrder,
        error: ''
    }
}

const getImgSegmentDatasetsError=(state, action)=> {
    return {
        ...state,
        error: action.error
    }
}

export default reduce(initialState,{
    [actionTypes.IMG_SEGMENT_QUERY_RECEIVED]: queryReceived,
    [actionTypes.IMG_SEGMENT_GET_TASK_CONF_SUCCESS]: getTaskConfigSuccess,
    [actionTypes.IMG_SEGMENT_GET_TASK_CONF_ERROR]: getTaskConfigError,
    [actionTypes.IMG_SEGMENT_OPEN_LIGHTBOX]: openLightbox,
    [actionTypes.IMG_SEGMENT_CLOSE_LIGHTBOX]: closeLightbox,
    [actionTypes.IMG_SEGMENT_UPDATE_ANSWER]: updateAnswer,
    [actionTypes.IMG_SEGMENT_SUBMIT_SUCCESS]: submitSuccess,
    [actionTypes.IMG_SEGMENT_SUBMIT_ERROR]: submitError,
    [actionTypes.IMG_SEGMENT_TASK_COMPLETED]: taskCompleted,
    [actionTypes.IMG_SEGMENT_GET_CURRENT_QUESTION_SUCCESS]: getCurrentQuestionSuccess,
    [actionTypes.IMG_SEGMENT_GET_CURRENT_QUESTION_ERROR]: getCurrentQuestionError,
    [actionTypes.IMG_SEGMENT_GET_NEXT_SEGMENT_DATASET_SUCCESS]: getNextSegmentDatasetSuccess,
    [actionTypes.IMG_SEGMENT_GET_NEXT_SEGMENT_DATASET_ERROR]: getNextSegmentDatasetError,
    [actionTypes.GET_IMG_SEGMENT_DATASETS_SUCCESS]: receivedImgSegmentDatasets,
    [actionTypes.GET_IMG_SEGMENT_DATASETS_ERROR]: getImgSegmentDatasetsError
});


// WEBPACK FOOTER //
// ./src/redux/imgSegment/reducer.js